async function fetchProductData(handle) {
    const url = window.Shopify.routes.root + 'products/' + handle + '.js';
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch product data for ${handle}`);
        }
        const product = await response.json();
        return product;
    } catch (error) {
        console.error('Error fetching product data:', error);
        throw error;
    }
}

function generateProductCard(productData) {
    const image_url = productData.featured_image.replace('.jpg', '_400x.jpg').replace('.png', '_400x.png');
    const image_url_2x = productData.featured_image.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
    const price = productData.price / 100;
    const compare_at_price = productData.compare_at_price / 100;
    const isOnSale = compare_at_price > price;
    const discount_rate = isOnSale ? Math.round((compare_at_price - price) * 100.0 / compare_at_price) : '';
    const sale_badge = isOnSale ? '<span class="sale-badge">SALE</span>' : '';
    const compare_at_price_render = isOnSale ? `<s>${compare_at_price.toLocaleString()}<small>円</small></s>` : '';
    const product_card = `
    <div class="product-card">
        <figure class="product-card-image">
            <a href="${productData.url}" class="image-link">
                <img src="${image_url}" srcset="${image_url_2x} 2x" width="200" height="200" loading="lazy" alt="${productData.title}">
            </a>
        </figure>
        <h3 class="product-card-title">
            ${sale_badge}<a href="${productData.url}" class="title-link">${productData.title}</a>
        </h3>
        <p class="product-card-vendor"><small>${productData.vendor}</small></p>
        <p class="product-card-rate"><span>${discount_rate}%OFF</span></p>
        <p class="product-card-price">
            <span class="regular-price"><strong>${price.toLocaleString()}</strong><small>円/税込</small></span>${compare_at_price_render}
        </p>
    </div>
    `;
    return product_card;
}

function generateItemList(productData, cardText) {
    const image_url = productData.featured_image.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png');
    const image_url_2x = productData.featured_image.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png');
    const product_card = `
    <a href="${productData.url}" class="itemlist-link">
        <img src="${image_url}" srcset="${image_url_2x} 2x" width="80" height="80" loading="lazy" alt="${productData.title}">
        <span>${cardText}</span>
    </a>
    `;
    return product_card;
}

const shortcodeSelectors = ['.sc-product', '.sc-collection', '.sc-itemlist > [data-handle]'];

shortcodeSelectors.forEach(async (selector) => {
    const shortcodes = document.querySelectorAll(selector);

    for (const code of shortcodes) {
        const data_handle = code.getAttribute('data-handle');
        const handles = data_handle.split(',');

        const productCards = [];

        switch (selector) {
            case '.sc-collection':
                try {
                    const handle = code.getAttribute('data-handle');
                    const response = await fetch(window.Shopify.routes.root + 'collections/' + handle + '/products.json');
                    if (!response.ok) {
                        throw new Error(`Failed to fetch collection products for ${handle}`);
                    }
                    const responseData = await response.json();
                    const products = responseData.products;

                    if (!products || products.length === 0) {
                        throw new Error(`No products found for collection ${handle}`);
                    }

                    const dataItems = code.getAttribute('data-items');
                    const limit = dataItems ? parseInt(dataItems, 10) : 4;
                    const slice_products = products.slice(0, limit);
                    if ( limit >= 5 ) {
                        code.classList.add("grid-layout");
                    }

                    for (const product of slice_products) {
                        const productData = await fetchProductData(product.handle);
                        const productCard = generateProductCard(productData);
                        productCards.push(productCard);
                    }
                } catch (error) {
                    console.error('Error fetching and rendering collection:', error);
                }
                break;
            case '.sc-product':
                const items = handles.length;
                code.setAttribute('data-items', items);
                if ( items >= 5 ) {
                    code.classList.add("grid-layout");
                }
                for (const handle of handles) {
                    try {
                        const productData = await fetchProductData(handle);
                        const productCard = generateProductCard(productData);

                        productCards.push(productCard);
                    } catch (error) {
                        console.error('Error fetching and rendering product:', error);
                    }
                }
                break;
            case '.sc-itemlist > [data-handle]':
                const handle = code.getAttribute('data-handle');
                try {
                    const productData = await fetchProductData(handle);
                    const cardText = code.textContent;
                    const productCard = generateItemList(productData, cardText);

                    productCards.push(productCard, );
                } catch (error) {
                    console.error('Error fetching and rendering product:', error);
                }
                break;
        }

        code.innerHTML = productCards.join('');
    }
});
